import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import styles from '../styles/Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.section}>
          <h3>Britosa Mudanzas</h3>
          <p>Más de 25 años trasladando tus recuerdos con el cuidado que merecen. Mudanzas en Madrid y toda España.</p>
        </div>

        <div className={styles.section}>
          <h4>Contacto</h4>
          <div className={styles.contact}>
            <div><FaPhone /> <a href="tel:+34691604880">691 60 48 80</a></div>
            <div><FaEnvelope /> <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a></div>
            <div><FaMapMarkerAlt /> <span>C. Río Duero, 28934<br/>Móstoles, Madrid</span></div>
          </div>
        </div>

        <div className={styles.section}>
          <h4>Horario</h4>
          <div className={styles.contact}>
            <div><FaClock /> <span>Lunes a Domingo<br/>8:00 – 22:00</span></div>
          </div>
        </div>

        <div className={styles.section}>
          <h4>Enlaces</h4>
          <ul>
            <li><a href="/">Inicio</a></li>
            <li><a href="/servicios">Servicios</a></li>
            <li><a href="/nosotros">Nosotros</a></li>
            <li><a href="/presupuesto">Presupuesto</a></li>
            <li><a href="/blog/">Blog</a></li>
            <li><a href="/contacto">Contacto</a></li>
          </ul>
        </div>
      </div>

      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 2rem 2rem", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <h4 style={{ color: "#D97441", fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "1rem" }}>Zonas que cubrimos</h4>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem 1.5rem" }}>
          <Link to="/mudanzas-mostoles" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Móstoles</Link>
          <Link to="/mudanzas-madrid-centro" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Madrid Centro</Link>
          <Link to="/mudanzas-chamberi" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Chamberí</Link>
          <Link to="/mudanzas-alcorcon" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Alcorcón</Link>
          <Link to="/mudanzas-fuenlabrada" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Fuenlabrada</Link>
          <Link to="/mudanzas-getafe" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Getafe</Link>
          <Link to="/mudanzas-leganes" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Leganés</Link>
          <Link to="/mudanzas-salamanca" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Salamanca</Link>
          <Link to="/mudanzas-retiro" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Retiro</Link>
          <Link to="/mudanzas-tetuan" style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", textDecoration: "none" }}>Tetuán</Link>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>&copy; 2026 Britosa Mudanzas · Todos los derechos reservados</p>
        <div className={styles.legalLinks}>
          <Link to="/aviso-legal">Aviso Legal</Link>
          <span>·</span>
          <Link to="/politica-privacidad">Política de Privacidad</Link>
        </div>
      </div>
    </footer>
  );
}
